const TOGGLE_MENU = "TOGGLE_MENU";
const CLOSE_MENU = "CLOSE_MENU";
const obj = {
  TOGGLE_MENU,
  CLOSE_MENU,
};

export default obj
